import { ViewFactory } from 'wdc-cube-react'
import IntegracaoMonitoramentoScope, { HeaderScope } from '../integracao-monitoramento.scopes'
import HeaderView from './integracao-monitoramento.header'
import IntegracaoMonitoramentoView from './integracao-monitoramento.view'

export function registerViews(rv = ViewFactory.register) {
    rv(IntegracaoMonitoramentoScope, IntegracaoMonitoramentoView)
    rv(HeaderScope, HeaderView)
}
